module.exports = __webpack_public_path__ + "img/bb_m_4_ja.14f8d41e.jpg";